import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { News } from "@orion2/models/tocitem.models";
import { NewsUtilsService } from "@viewer/news/services/news-utils.service";

@Component({
  standalone: false,
  selector: "o-card-news",
  templateUrl: "./card-news.component.html",
  styleUrls: ["./card-news.component.scss"]
})
export class CardNewsComponent implements OnInit {
  @Input() news: News;
  @Output() toggleExpansion = new EventEmitter();
  public content: string;
  public isExpanded = false;

  constructor(private newsUtilsService: NewsUtilsService) {}

  ngOnInit(): void {
    if (!this.news.read) {
      this.expand();
    }
  }

  /**
   * Expand the card and get the news content it isn't already done
   */
  public expand(preventEmit = false): void {
    this.isExpanded = true;
    if (!preventEmit) {
      this.toggleExpansion.emit();
    }
    if (this.content === undefined) {
      this.getContent(this.news);
    }
  }

  /**
   * Reduce the card
   */
  public reduce(preventEmit = false): void {
    this.isExpanded = false;
    if (!preventEmit) {
      this.toggleExpansion.emit();
    }
  }

  public getContent(news: News): Promise<void> {
    return this.newsUtilsService.getContent(news).then((content: string) => {
      this.content = content;
    });
  }

  public markAsRead(news: News): Promise<void> {
    return this.newsUtilsService.markAsRead(news);
  }
}
